import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { insights } from '../data/site';
export function Insights() {
  const [featured, ...rest] = insights;
  return <main data-id="element-381" data-mp="253amuk0fraao">
      <section className="boardroom-light relative overflow-hidden pt-36 pb-20 lg:pt-44 lg:pb-24" data-id="element-382" data-mp="2a486z250aeet">
        <div className="aurora" aria-hidden="true" data-id="element-383" data-mp="2xtszabn1uo0r" />
        <div className="pattern-lattice-dark absolute inset-0 opacity-50" aria-hidden="true" data-id="element-384" data-mp="2xuaud4xz6w73" />
        <div className="relative mx-auto max-w-7xl px-6 lg:px-10" data-id="element-385" data-mp="31u38rya1vwkd">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-386" data-mp="2nw4u0rrthy4c">
            <div className="flex items-center gap-3" data-id="element-387" data-mp="1cgq0jxythodz">
              <span className="h-px w-10 bg-gold" aria-hidden="true" data-id="element-388" data-mp="1cf5422sxzvdh" />
              <p className="eyebrow text-gold" data-id="element-389" data-mp="1hgklzlztplrn">Executive Insights</p>
            </div>
            <h1 className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.1] text-white sm:text-5xl lg:text-[3.5rem]" data-id="element-390" data-mp="s2fy12zh7mp5">
              Writing on governance, risk, and the modern legal function.
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-300/90" data-id="element-391" data-mp="1226rr2g7pxo6">
              Perspectives drawn from fourteen years advising CEOs, Boards of Directors, and investors
              across FinTech, consumer finance, and publicly traded enterprises.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="bg-white py-20 lg:py-28" data-id="element-392" data-mp="16ynqeql1fufi">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-393" data-mp="1kqtyrqhy8x4e">
          <Reveal data-id="element-394" data-mp="1fssh9a0695v1">
            <article className="group grid overflow-hidden border border-navy/10 transition-all duration-500 hover:border-gold/60 hover:shadow-lux lg:grid-cols-[1.1fr_0.9fr]" data-id="element-395" data-mp="1fsim7809s8ih">
              <div className="p-10 lg:p-14" data-id="element-396" data-mp="1pqybd5fql7pc">
                <span className="eyebrow text-[0.6rem] text-gold" data-id="element-397" data-mp="1ps9fx7h0ajhi">Featured · {featured.category}</span>
                <h2 className="mt-5 font-display text-3xl font-light leading-tight text-navy lg:text-4xl" data-id="element-398" data-mp="1wvhha8jrqvsa">
                  {featured.title}
                </h2>
                <p className="mt-5 max-w-xl text-base leading-relaxed text-charcoal/75" data-id="element-399" data-mp="26ru7uxk0otit">
                  {featured.excerpt}
                </p>
                <div className="mt-8 flex flex-wrap items-center gap-6 text-xs text-charcoal/55" data-id="element-400" data-mp="2bkdjvq323gli">
                  <span data-id="element-401" data-mp="2ghvvjo8gk9x7">{featured.date}</span>
                  <span className="flex items-center gap-1.5" data-id="element-402" data-mp="2kjh4wzlsa62n">
                    <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-403" data-mp="2kltw83dflssd" />
                    {featured.readTime}
                  </span>
                </div>
                <span className="mt-8 inline-flex items-center gap-2 text-[0.7rem] uppercase tracking-micro text-royal transition-colors duration-300 group-hover:text-gold" data-id="element-404" data-mp="2ugvlr0bmcwvh">
                  Read the article
                  <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-405" data-mp="104oyh35gapmt" />
                </span>
              </div>
              <div className="boardroom-light relative min-h-[14rem]" data-id="element-406" data-mp="ntxwpa8zlyoe">
                <div className="pattern-lattice-dark absolute inset-0 opacity-60" aria-hidden="true" data-id="element-407" data-mp="nrtju2t41pbz" />
                <div className="relative flex h-full items-center justify-center p-10" data-id="element-408" data-mp="is8ixmudr6wm">
                  <span className="font-display text-6xl font-light text-white/15 lg:text-7xl" data-id="element-409" data-mp="dtdt40xzwi30">01</span>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="mt-8 grid gap-px border border-navy/10 bg-navy/10 md:grid-cols-2" data-id="element-410" data-mp="16kp6gcwvzr3b">
            {rest.map((article, index) => <Reveal key={article.slug} delay={index % 2 * 0.07} data-id="element-411" data-mp="wm898y7cug8t" data-mpi={index}>
                <article className="group relative h-full bg-white p-9 transition-colors duration-500 hover:bg-mist" data-id="element-412" data-mp="wo2jnil02pyn">
                  <div className="flex items-center justify-between" data-id="element-413" data-mp="3hc72e1jqqkrd">
                    <span className="eyebrow text-[0.6rem] text-gold" data-id="element-414" data-mp="3havxfyek76yo">{article.category}</span>
                    <span className="text-xs text-charcoal/45" data-id="element-415" data-mp="19zffwui3oecj">{article.readTime}</span>
                  </div>
                  <h2 className="mt-5 font-display text-2xl font-light leading-snug text-navy" data-id="element-416" data-mp="1etthxfr9pjq6">
                    {article.title}
                  </h2>
                  <p className="mt-4 text-sm leading-relaxed text-charcoal/70" data-id="element-417" data-mp="1514bizakqw1p">{article.excerpt}</p>
                  <div className="mt-7 flex items-center justify-between border-t border-navy/10 pt-5 text-xs text-charcoal/50" data-id="element-418" data-mp="1sr88wox65zk9">
                    {article.date}
                    <span className="flex items-center gap-1.5 text-royal transition-colors duration-300 group-hover:text-gold" data-id="element-419" data-mp="1itc1a73fxmqw">
                      Read
                      <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-420" data-mp="1nqu197zhcrmr" />
                    </span>
                  </div>
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gold transition-all duration-500 group-hover:w-full" data-id="element-421" data-mp="cdi41fy8779k" />
                </article>
              </Reveal>)}
          </div>
        </div>
      </section>
    </main>;
}